import React from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";

const DeepSeekUsageCharts = ({ stats, t }) => {
    const dailyUsage = stats?.DailyUsage || [];

    // Separate Chart 1: Daily Messages / Conversations
    const chatsChartData = {
        labels: dailyUsage.map(d => d.DateStr),
        datasets: [
            {
                label: t('Pages.DeepSeekAdmin.chatsCount') || "عدد المحادثات والرسائل",
                data: dailyUsage.map(d => d.ChatCount),
                borderColor: '#92278f',
                backgroundColor: 'rgba(146, 39, 143, 0.04)',
                fill: true,
                tension: 0.35,
                borderWidth: 2,
                pointRadius: 3,
                pointHoverRadius: 5
            }
        ]
    };

    const chatsChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                mode: 'index',
                intersect: false,
                bodyFont: { family: 'Cairo' },
                titleFont: { family: 'Cairo' }
            }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { font: { family: 'Cairo', size: 10 } }
            },
            y: {
                position: 'right',
                ticks: { font: { family: 'Cairo', size: 10 } },
                title: { display: true, text: t('Pages.DeepSeekAdmin.chatsCount') || "عدد المحادثات والرسائل", font: { family: 'Cairo', size: 11, weight: 'bold' } }
            }
        }
    };

    // Separate Chart 2: Daily Cost in USD
    const costChartData = {
        labels: dailyUsage.map(d => d.DateStr),
        datasets: [
            {
                label: t('Pages.DeepSeekAdmin.costUSD') || "التكلفة (USD)",
                data: dailyUsage.map(d => d.TotalSpent),
                borderColor: '#22c55e',
                backgroundColor: 'rgba(34, 197, 94, 0.04)',
                fill: true,
                tension: 0.35,
                borderWidth: 2,
                pointRadius: 3,
                pointHoverRadius: 5
            }
        ]
    };

    const costChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                mode: 'index',
                intersect: false,
                bodyFont: { family: 'Cairo' },
                titleFont: { family: 'Cairo' }
            }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { font: { family: 'Cairo', size: 10 } }
            },
            y: {
                position: 'left',
                ticks: { font: { family: 'Cairo', size: 10 } },
                title: { display: true, text: t('Pages.DeepSeekAdmin.costUSD') || "التكلفة (USD)", font: { family: 'Cairo', size: 11, weight: 'bold' } }
            }
        }
    };

    return (
        <div className="row g-4 mt-2">
            <div className="col-lg-6 col-12">
                <div className="deepseek-chart-container text-right">
                    <h5 className="mb-3 font-weight-bold small text-muted">
                        <i className="fal fa-chart-bar ml-2 text-primary" style={{ fontSize: '14px' }}></i>
                        {t('Pages.DeepSeekAdmin.dailyChatsChart') || "الاستهلاك اليومي (عدد المحادثات والرسائل)"}
                    </h5>
                    <div style={{ height: '240px', position: 'relative' }}>
                        {stats && dailyUsage.length > 0 ? (
                            <Line data={chatsChartData} options={chatsChartOptions} />
                        ) : (
                            <div className="text-center py-5 text-muted small">
                                {t('Pages.DeepSeekAdmin.noChartData') || "لا توجد بيانات استهلاك لعرض المخطط خلال آخر 30 يوم"}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-12">
                <div className="deepseek-chart-container text-right">
                    <h5 className="mb-3 font-weight-bold small text-muted">
                        <i className="fal fa-usd-circle ml-2 text-danger" style={{ fontSize: '14px' }}></i>
                        {t('Pages.DeepSeekAdmin.dailyCostChart') || "الاستهلاك اليومي (التكلفة بالدولار)"}
                    </h5>
                    <div style={{ height: '240px', position: 'relative' }}>
                        {stats && dailyUsage.length > 0 ? (
                            <Line data={costChartData} options={costChartOptions} />
                        ) : (
                            <div className="text-center py-5 text-muted small">
                                {t('Pages.DeepSeekAdmin.noChartData') || "لا توجد بيانات استهلاك لعرض المخطط خلال آخر 30 يوم"}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeepSeekUsageCharts;
